import { TradingHourDay } from '@scentregroup/shared/graphql'
import { StoreTradingSchedule } from './parse-opening-hours/types'

export function mapStoreTradingHourDayToTradingSchedule(
  tradingHours: TradingHourDay[]
): StoreTradingSchedule {
  return {
    isStoreCentreLinked: true,
    tradingHours,
  }
}
